import React from 'react';
import { connect } from "react-redux";
import { preloaderShow, preloaderHide, alert } from '../../../actions';
import TranslationService from "../../../app/services/TranslationService";
import axios from "axios";
import {config} from "../../../app/config";
import {Button} from "../../icymat-design/Button";


class CalendarsDialogClass extends React.Component
{
    constructor(props) {
        super(props);

        this.state = {
            data: []
        }
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (!prevProps.opened && prevProps.opened !== this.props.opened) {
            this.loadData();
        }
    };

    loadData = () => {
        this.props.preloaderShow();
        let that = this;

        that.setState({data: []});
        axios.get(config.apiAddress + '/app/calendar/calendars')
            .then(function (response) {
                that.setState({data: response.data});
                that.props.preloaderHide();
            }).catch(function(error) {
                that.props.alert(TranslationService.trans(that.props.language, 'calendars.data_loading_error'));
                that.props.preloaderHide();
            });
    }

    renderCalendars = () => {
        let rows = [];

        let that = this;
        this.state.data.forEach(function(calendar, key) {
            rows.push(<div key={key}>
                {that.props.user.subscription !== 'standard' ?
                    <span className={'imd-icon imd-icon-bell imd-text-' + (calendar.reminders ? 'green' : 'red')}
                          style={{float: 'right', cursor: 'pointer'}}
                          onClick={() => that.changeRemindersSettings(key)}
                    />
                    : null
                }
                <div className={'calendar-color imd-bg-' + calendar.color} />
                <strong>{calendar.name}</strong><br /><br />
                <span title={calendar.url} style={{display: 'inline-block', width: '100%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                    {calendar.url}
                </span>

                <Button
                    color={'red'}
                    secondary={true}
                    size={'sm'}
                    text={TranslationService.trans(that.props.language, 'common.delete')}
                    onClick={() => that.props.delete(config.apiAddress + '/app/calendar/calendars/' + key)}
                />

                <hr />
            </div>);
        });

        return rows;
    }

    changeRemindersSettings = (index) => {
        this.props.preloaderShow();
        let that = this;

        axios.patch(config.apiAddress + '/app/calendar/calendars/' + index)
            .then(function (response) {
                that.loadData();
            }).catch(function(error) {
                that.props.alert(TranslationService.trans(that.props.language, 'calendars.data_loading_error'));
                that.props.preloaderHide();
            });
    }

    /**
     * @returns {JSX.Element}
     */
    render() {
        return (
            <dialog className={'imd-dialog imd-bg-blur-black' + (this.props.opened ? ' imd-opened' : '')}>
                <div className="imd-dialog-body imd-bg-20-default imd-text-accent">
                    <header>
                        {TranslationService.trans(this.props.language, 'calendars.subscribed_calendars.title')}
                        <span className="imd-icon imd-icon-xmark imd-dialog-close" onClick={() => this.props.close()} />
                    </header>

                    <div className="imd-dialog-content">
                        {this.renderCalendars()}
                    </div>

                    <footer>
                        <Button
                            color={'accent'}
                            secondary={true}
                            text={TranslationService.trans(this.props.language, 'common.close')}
                            onClick={() => this.props.close()}
                        />
                    </footer>
                </div>
            </dialog>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        language: TranslationService.getLanguage(state.user)
    }
};

export const CalendarsDialog = connect(mapStateToProps, {preloaderShow, preloaderHide, alert})(CalendarsDialogClass);
